import Box from '@material-ui/core/Box';
import styled from 'styled-components';
import { getSvgPath, mediaUrls } from 'globalconfig/constants/mediaUrls';

const Wrapper = styled(Box)`
  ${({ theme }) => `
  padding: 3%;
  display: flex;
  flex-direction: column;
  form {
    flex-direction: column;
    width: 100%;
  }
  .test-table {
    width: 100%;
    border: 2px solid  ${theme.colors.PRIMARY_BORDER};
    border-collapse: collapse;
    thead td {
      color: ${theme.colors.LINK_COLOR};
      padding: 8px;
      padding-left: 0;
    }
    tr {
      border-bottom: 0.5px solid  ${theme.colors.PRIMARY_BORDER};
      td {
      color: ${theme.colors.PRIMARY_CONTRAST};
      padding: 8px;
      
      }
    }
    .title {
      color: ${theme.colors.LINK_COLOR};
    }
  }
.icon-td {
  .icon-td-svg {
    svg {
      color: #fff !important;
      width: 20px;
      height: 20px;
      circle, path {
        stroke-width: 3;
      }
   }
   div > div {
    justify-content: left;
   }   
  }    
}
  .buttonStyle {
    margin-top: 0 !important;
  }
  `}
`;
const TableWrapper = styled(Box)`
  padding-top: 2%;
`;

const Styled = { Wrapper, TableWrapper };

export default Styled;
